// List of Activities — Sub-Activities for Occupation field

export interface OccupationCategory {
  name: string;
  subActivities: string[];
}

export const OCCUPATION_CATEGORIES: OccupationCategory[] = [
  {
    name: 'Research & Education',
    subActivities: [
      'Universities and Engineering Schools',
      'Public Research Institutes',
      'Laboratories and Research Centers',
      'Technical Institutes',
      'Researchers',
      'FabLabs & Prototyping Workshops',
      'Field Testing Platforms',
      'Other'
    ]
  },
  {
    name: 'Agricultural Stakeholders',
    subActivities: [
      'Farmers / Agricultural Operators',
      'Agricultural Cooperatives',
      'Chambers of Agriculture',
      'Professional Agricultural Organizations (PAOs)',
      'Clusters / Producer Groups',
      'Rural Associations',
      'Other'
    ]
  },
  {
    name: 'Companies & Economic Actors',
    subActivities: [
      'SMEs / Micro-enterprises',
      'Large Companies',
      'Agrifood Companies',
      'AgTech / FoodTech Startups',
      'Clusters and Groupings',
      'Engineering / Consulting Firms',
      'Consulting Offices',
      'Other'
    ]
  },
  {
    name: 'Public Institutions & Authorities',
    subActivities: [
      'Ministries',
      'Public Administration & Public Establishments',
      'Municipalities / Local Authorities',
      'Public Agencies',
      'European Funds Managing Authorities',
      'Observatories and Data Centers',
      'Regulatory Bodies',
      'Other'
    ]
  },
  {
    name: 'Civil Society & Users',
    subActivities: [
      'Citizen Collectives',
      'Influencers',
      'NGOs and User Associations',
      'Representatives of Final Beneficiaries',
      'End-User Groups',
      'Inclusion & Equal Opportunity Organizations',
      'Disability & Accessibility Stakeholders',
      'Youth Innovation Councils',
      'Other'
    ]
  },
  {
    name: 'Innovation & Transition Stakeholders',
    subActivities: [
      'Innovation Hubs',
      'Territorial Innovation Clusters',
      'Technology Transfer Centers',
      'Lawyers and Legal Experts (IP, Patents, Regulations)',
      'Public Institutes',
      'Cross-cutting Experts & Ethics',
      'Training & Skills Institutes',
      'Standards and Standardization Experts',
      'Telecom Operators, ICT, Industry 4.0',
      'Computing Centers / AI / Big Data',
      'Renewable Energy Operators',
      'Other'
    ]
  },
  {
    name: 'Funders & Economic Support',
    subActivities: [
      'Banks, Insurance Companies',
      'Investment Funds',
      'Venture Capital / Business Angels',
      'Foundations',
      'Grant Programs & Funding Bodies',
      'Chambers of Commerce',
      'Economic Development Agencies',
      'Trade, Logistics, Distribution',
      'Manufacturing & Prototyping',
      'Other'
    ]
  },
  {
    name: 'Communication & Dissemination',
    subActivities: [
      'Media & Press',
      'Libraries',
      'Communication Agencies',
      'Dissemination & Results Exploitation Experts',
      'Trade Fairs, Exhibitions',
      'Other'
    ]
  },
  {
    name: 'International Stakeholders',
    subActivities: [
      'International Organizations (FAO, OECD, UNESCO…)',
      'International NGOs',
      'Cross-border Cooperation Programs',
      'Other'
    ]
  }
];

// Flattened list of all occupations for easy searching/filtering
export const ALL_OCCUPATIONS: string[] = OCCUPATION_CATEGORIES.flatMap(
  category => category.subActivities.map(sub => `${category.name} - ${sub}`)
);

// Get all unique sub-activities (without category prefix)
export const ALL_SUB_ACTIVITIES: string[] = Array.from(
  new Set(OCCUPATION_CATEGORIES.flatMap(category => category.subActivities))
);
